import { useState, useEffect } from 'react'
import School from '../models/School'

const initialData = () => {
  const schoolsCache = localStorage.getItem('schools')

  if (!schoolsCache) return []

  return JSON.parse(schoolsCache).map((schoolParams) => new School(schoolParams))
}

const useSchools = () => {
  const [schools, setSchools] = useState([])

  useEffect(() => {
    const fetchSchools = async () => {
      const { data } = await School
        .where({ sales_stat: { eq: ['CUST', 'XCUST', 'NCUST'] } } )
        .order({ name: 'asc' })
        .all()

      localStorage.setItem('schools', JSON.stringify(data))

      setSchools(data)
    };

    fetchSchools()
  }, [])

  return schools
}

export default useSchools
